import React from "react"
import { StaticQuery, graphql } from "gatsby"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import { Row, Col } from "react-bootstrap"
import ScrollAnimation from "react-animate-on-scroll"
import SteveImg from "./steve-img"
import SteveMobileImg from "./steve-mobile-img"
import OurStoryPageStyle from "./our-story-page.module.scss"

const Steve = () => (
    <StaticQuery query={graphql`
        query Steve{
            contentfulOurStoryPage{
                ourStoryReference{
                 sectionContent2{
                      subtitle{
                        subtitle
                          }
                      sectionParagraph{
                        json
                      }
                    }
                }
            }
        }
    `}
    render={data => (
    <div className={OurStoryPageStyle.sectionDiv}>
        <Row className={OurStoryPageStyle.steveRow1}>
            <Col md={5} className={OurStoryPageStyle.steveCol1}>
                <div className={OurStoryPageStyle.sectionDescriptionLeftAlign}>
                    <ScrollAnimation animateIn="fadeInUp" duration={2} animateOnce={true}>
                        <SteveImg />
                        <SteveMobileImg />
                    </ScrollAnimation>
                </div>
            </Col>
            <Col md={7} className={OurStoryPageStyle.steveCol2}>
                <h3 className={OurStoryPageStyle.sectionTitleLeftAlign}>{data.contentfulOurStoryPage.ourStoryReference.sectionContent2.subtitle.subtitle}</h3>
                <div className={OurStoryPageStyle.sectionDescriptionLeftAlign}>
                {documentToReactComponents(data.contentfulOurStoryPage.ourStoryReference.sectionContent2.sectionParagraph.json)}
                </div>
            </Col>
        </Row>
    </div>
    )}
    />
)

export default Steve